import { getHeaders } from '../xhrRequest';
import { createAction } from 'redux-api-middleware';

export const FETCH_DICTIONARY = 'FETCH_DICTIONARY';
export const FETCH_DICTIONARY_SUCCESS = 'FETCH_DICTIONARY_SUCCESS';
export const FETCH_DICTIONARY_FAILURE = 'FETCH_DICTIONARY_FAILURE';

export const FETCH_DEPENDENCY = 'FETCH_DEPENDENCY';
export const FETCH_DEPENDENCY_SUCCESS = 'FETCH_DEPENDENCY_SUCCESS';
export const FETCH_DEPENDENCY_FAILURE = 'FETCH_DEPENDENCY_FAILURE';

export const fetchDictionary = () => createAction({
    types: [
        FETCH_DICTIONARY,
        {
            type: FETCH_DICTIONARY_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json;
                });
            }
        },
        FETCH_DICTIONARY_FAILURE
    ],
    endpoint: `/api/order-dictionary/transcription`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
});

export const fetchDependency = () => createAction({
    types: [
        FETCH_DEPENDENCY,
        {
            type: FETCH_DEPENDENCY_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json;
                });
            }
        },
        FETCH_DEPENDENCY_FAILURE
    ],
    endpoint: `/api/file/dependency`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
});